import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'

import 'amfe-flexible'

import Vant from 'vant'
import 'vant/lib/index.css'

// 加载全局样式
import './styles/index.less'
// 引入字体样式
import "@/styles/font.css";

Vue.use(Vant)
Vue.use(ElementUI);

Vue.config.productionTip = false
// 路由切换时修改标题
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '问卷' // 没有写 meta.title 的时候用默认
  }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
